import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { labels } from '../properties/labelsMapping'

@Injectable({
  providedIn: 'root'
})
export class LabelTransformService {
  private transformEnabled = false;
  private settingsLabels: Map<string, string> = null;
  private cache = new Map<string, string>();
  constructor(private http: HttpClient) { }

  set transformText(value: boolean) {
    this.transformEnabled = value;
  }

  get transformText(): boolean {
    return this.transformEnabled;
  }

  set settingsLabel(settingsLabels:Map<string, string>) {
    this.settingsLabels = settingsLabels;
  }

  replace(text: string): string {
    if (!this.transformEnabled || !text || !this.settingsLabels) return text;
    if (this.cache.has(text)) {
      return this.cache.get(text)!;
    }
    if(this.settingsLabels[text]){
      return this.settingsLabels[text];
    }else{
      console.log("Match not found"+text,this.settingsLabels)
      return text;
    }
    //the below logic is to do string replacement
    /*let result = text;
    for (const [original, replacement] of Object.entries()) {
      const regex = new RegExp(`\\b${original}\\b`, 'gi');
      result = result.replace(regex, replacement);
    }
    this.cache.set(text, result);
    return result;*/
  }
}
